import React from 'react';
import { FareData } from '../../types/fare';

interface PriceRangeBarProps {
  fare: FareData;
}

export default function PriceRangeBar({ fare }: PriceRangeBarProps) {
  // Safety check
  if (!fare || !fare.min || !fare.max || !fare.base || !fare.ceiling) {
    return null;
  }

  const { min, max, base, ceiling } = fare;

  // FIXED positions - never change
  const fairPricePos = 10;
  const goodDealPos = 40;
  const highPos = 70;
  const overpricedPos = 90;

  return (
    <div className="mt-3 md:mt-6 px-1 md:px-2">
      {/* Top labels - FIXED positions */}
      <div className="relative mb-1 md:mb-2 text-[10px] md:text-xs text-gray-600" style={{ height: '14px' }}>
        <div 
          className="absolute whitespace-nowrap text-[9px] md:text-xs" 
          style={{ left: `${fairPricePos}%`, transform: 'translateX(-50%)' }}
        >
          Fair Price
        </div>
        <div 
          className="absolute whitespace-nowrap text-[9px] md:text-xs" 
          style={{ left: `${goodDealPos}%`, transform: 'translateX(-50%)' }}
        >
          Good Deal
        </div>
        <div 
          className="absolute whitespace-nowrap text-[9px] md:text-xs" 
          style={{ left: `${highPos}%`, transform: 'translateX(-50%)' }}
        >
          High
        </div>
        <div 
          className="absolute whitespace-nowrap text-[9px] md:text-xs" 
          style={{ left: `${overpricedPos}%`, transform: 'translateX(-50%)' }}
        >
          Overpriced
        </div>
      </div>

      {/* Gradient bar with FIXED markers */}
      <div 
        className="relative h-3 md:h-4 rounded-full overflow-hidden" 
        style={{
          background: 'linear-gradient(to right, #22c55e 0%, #22c55e 40%, #eab308 55%, #f97316 70%, #ef4444 90%, #dc2626 100%)'
        }}
      >
        {/* FIXED Price markers at same positions */}
        <div
          className="absolute top-0 bottom-0 w-0.5 bg-gray-900"
          style={{ left: `${fairPricePos}%` }}
        />
        <div
          className="absolute top-0 bottom-0 w-0.5 bg-blue-600"
          style={{ left: `${goodDealPos}%` }}
        />
        <div
          className="absolute top-0 bottom-0 w-0.5 bg-gray-900"
          style={{ left: `${highPos}%` }}
        />
        <div
          className="absolute top-0 bottom-0 w-0.5 bg-red-600"
          style={{ left: `${overpricedPos}%` }}
        />
      </div>

      {/* Bottom labels - FIXED positions, only values change */}
      <div className="relative mt-2 md:mt-3 text-[10px] md:text-xs" style={{ height: '32px' }}>
        {/* Min - Fixed at 10% */}
        <div 
          className="absolute whitespace-nowrap text-center" 
          style={{ left: `${fairPricePos}%`, transform: 'translateX(-50%)' }}
        >
          <div className="text-gray-600 font-medium mb-0.5 md:mb-1">Min</div>
          <div className="font-semibold text-gray-900 text-[10px] md:text-xs">Rs. {min.toLocaleString()}</div>
        </div>
        
        {/* Avg - Fixed at 40% */}
        <div 
          className="absolute whitespace-nowrap text-center" 
          style={{ left: `${goodDealPos}%`, transform: 'translateX(-50%)' }}
        >
          <div className="text-gray-600 font-medium mb-0.5 md:mb-1">Avg</div>
          <div className="font-semibold text-blue-600 text-[10px] md:text-xs">Rs. {base.toLocaleString()}</div>
        </div>
        
        {/* Max - Fixed at 70% */}
        <div 
          className="absolute whitespace-nowrap text-center" 
          style={{ left: `${highPos}%`, transform: 'translateX(-50%)' }}
        >
          <div className="text-gray-600 font-medium mb-0.5 md:mb-1">Max</div>
          <div className="font-semibold text-gray-900 text-[10px] md:text-xs">Rs. {max.toLocaleString()}</div>
        </div>
        
        {/* Ceiling - Fixed at 90% */}
        <div 
          className="absolute whitespace-nowrap text-center" 
          style={{ left: `${overpricedPos}%`, transform: 'translateX(-50%)' }}
        >
          <div className="text-gray-600 font-medium mb-0.5 md:mb-1">Ceiling</div>
          <div className="font-semibold text-red-600 text-[10px] md:text-xs">Rs. {ceiling.toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
}

